import styled from 'styled-components';

export const Select = styled.div`
  padding: 10px;
  background-color: #fff;
`;

export const DropzoneWrapper = styled.div`
  .dropzone {
    border: dashed 3px #979797;
    border-radius: 6px;
    padding: 15px 25px;
    width: 100%;
    margin: 0;
    z-index: 2;
    cursor: pointer;
  }

  .dropzone-active {
    border-color: #blue;
  }

  .dropzone-reject {
    border-color: #FF7062;
  }
`;

export const InputGroup = styled.div`
  position: relative;
  label {
    display: block;
    font-size: 14px;
  }

  input[type="text"],
  input[type="password"],
  input[type="email"] {
    border-radius: 4px;
    border: solid 1px #979797;
    color: #000;
    display: block;
    font-size: 14px;
    margin-bottom: 5px;
    padding-left: 10px;
    width: 100%;

    &:focus {
      outline: none;
    }
  }

  .error, .warning {
    font-size: 12px;
    position: absolute;
    right: 15px;
    top: 37px;
  }

  .field-error {
    ::placeholder {
      color: #FF7062;
    }
  }

  .field-error, .error {
    color: #FF7062;
  }

  .warning {
    color: yellow;
  }

  .btn {
    background: #FF7062;
    border-radius: 100px;
    border: 0;
    color: white;
    font-family: system-ui, sans-serif;
    font-size: 1rem;
    line-height: 1.2;
    white-space: nowrap;
    text-decoration: none;
    padding: 0.25rem 0.5rem;
    margin: 0.25rem;
    cursor: pointer;
  }
`;

export const SubmitButton = styled.button`
  background: #FF7062;
  border-radius: 6px;
  border: 0;
  color: white;
  cursor: pointer;
  font-size: 16px;
  margin-top: 20px;
  text-decoration: none;
  text-transform: uppercase;
  width: 100%;
`;

export const Links = styled.div`
  font-size: 14px;
  text-align: center;

  a {
    color: #FF7062;
  }
`;
